export const GET_CHAT_ROOMS = "chat/GET_ROOMS";
export const GET_CHATS = "chat/GET_CHATS";
export const CREATE_CHAT = "chat/CREATE";
export const UPDATE_CHAT = "chat/UPDATE";
